module.exports = __webpack_public_path__ + "assets/img/xzhz_img.5170c598.png";